import BlStepperStatusMv from './BlStepperStatusMv.vue'

BlStepperStatusMv.install = function(Vue) {
  Vue.component(BlStepperStatusMv.name, BlStepperStatusMv)
}

export default BlStepperStatusMv
